import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import RouteService from '../../../services/RouteService';
import HelperNavigation from '../../common/HelperNavigation';
import globalTranslations from '../../../i18n/globalTranslations';
import Paths from '../../../types/Paths';
import MyAccountChangePasswordForm from '../MyAccountChangePasswordForm';
import PageTitle from '../../common/PageTitle';
import SEOTitle from '../../head/SEOTitle';
import AccountStore from '../../../store/AccountStore';
import { modelOf } from '../../../prop-types';

@observer
export class MyAccountChangePassword extends Component {
  getBreadcrumbsPath = () => {
    const { accountStore, intl, routeService } = this.props;
    return routeService.transformBreadCrumbs([
      {
        text: intl.formatMessage(globalTranslations.myAccount),
        url: accountStore.isBalanceBuyer
          ? Paths.MyAccountBalanceUser
          : Paths.MyAccount
      },
      {
        text: intl.formatMessage(globalTranslations.myAccountChangePassword),
        url: Paths.MyAccountChangePassword
      }
    ]);
  };

  render() {
    return (
      <Fragment>
        <SEOTitle title={globalTranslations.myAccountChangePassword} />
        <HelperNavigation breadcrumbsPath={this.getBreadcrumbsPath()} />
        <div className="MyAccountChangePassword">
          <PageTitle>
            <FormattedMessage {...globalTranslations.myAccountChangePassword} />
          </PageTitle>
          <MyAccountChangePasswordForm />
        </div>
      </Fragment>
    );
  }
}

MyAccountChangePassword.propTypes = {
  accountStore: modelOf(AccountStore).isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(
  inject('accountStore', 'routeService')(MyAccountChangePassword)
);



// WEBPACK FOOTER //
// ./src/components/my-account/MyAccountChangePassword/index.jsx